import { render, staticRenderFns } from "./TabAppointments.vue?vue&type=template&id=0d141485"
import script from "./TabAppointments.vue?vue&type=script&setup=true&lang=js"
export * from "./TabAppointments.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports